module.exports = __webpack_public_path__ + "static/media/pranavraj.c60f4592.jpg";